import React from "react";
import styled from "styled-components";
import { Link, NavLink } from "react-router-dom";
import { IoLocation } from "react-icons/io5";
import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";

const Offcanvas = ({ menuOpen, closeMenu }) => {
  return (
    <Wrapper>
      <div className="fix">
        <div
          className={`offcanvas-area ${menuOpen ? "info-open" : ""}`}
          data-lenis-prevent
        >
          <div className="offcanvas-wrapper">
            <div className="offcanvas-content">
              <div className="offcanvas-top d-flex justify-content-between align-items-center mb-20">
                <div className="offcanvas-logo">
                  <Link className="logo-black" to="index">
                    <img src="/assets/images/logo/logo-orange.png" alt="logo" />
                  </Link>
                </div>
                <div className="offcanvas-close" onClick={closeMenu}>
                  <button className="offcanvas-close-icon animation--flip">
                    <span className="offcanvas-m-lines">
                      <span className="offcanvas-m-line line--1"></span>
                      <span className="offcanvas-m-line line--2"></span>
                      <span className="offcanvas-m-line line--3"></span>
                    </span>
                  </button>
                </div>
              </div>

              {/* <div className="offcanvas-about mb-30 d-none d-sm-block">
                <p>
                  Industrie is Link modern factory website. specifically
                  designed for who need construction, firms, oil, architecture
                  and any other small business.
                </p>
              </div>
              <div className="offcanvas-gallery d-none d-sm-block">
                <div className="offcanvas-gallery-thumb-wrapper">
                  <div className="offcanvas-popup-thumb">
                    <Link
                      className="popup-image"
                      to="/assets/images/gallery/gallery-thumb-01.png"
                    >
                      <img
                        src="/assets/images/gallery/gallery-thumb-01.png"
                        alt="imagee"
                      />
                    </Link>
                  </div>
                  <div className="offcanvas-popup-thumb">
                    <Link
                      className="popup-image"
                      to="/assets/images/gallery/gallery-thumb-02.png"
                    >
                      <img
                        src="/assets/images/gallery/gallery-thumb-02.png"
                        alt="imagee"
                      />
                    </Link>
                  </div>
                  <div className="offcanvas-popup-thumb">
                    <Link
                      className="popup-image"
                      to="/assets/images/gallery/gallery-thumb-03.png"
                    >
                      <img
                        src="/assets/images/gallery/gallery-thumb-03.png"
                        alt="imagee"
                      />
                    </Link>
                  </div>
                  <div className="offcanvas-popup-thumb">
                    <Link
                      className="popup-image"
                      to="/assets/images/gallery/gallery-thumb-04.png"
                    >
                      <img
                        src="/assets/images/gallery/gallery-thumb-04.png"
                        alt="imagee"
                      />
                    </Link>
                  </div>
                  <div className="offcanvas-popup-thumb">
                    <Link
                      className="popup-image"
                      to="/assets/images/gallery/gallery-thumb-05.png"
                    >
                      <img
                        src="/assets/images/gallery/gallery-thumb-05.png"
                        alt="imagee"
                      />
                    </Link>
                  </div>
                  <div className="offcanvas-popup-thumb">
                    <Link
                      className="popup-image"
                      to="/assets/images/gallery/gallery-thumb-01.png"
                    >
                      <img
                        src="/assets/images/gallery/gallery-thumb-01.png"
                        alt="imagee"
                      />
                    </Link>
                  </div>
                </div>
              </div> */}

              <div className="mobile-menu">
                <div className="rs-offcanvas-menu mb-25">
                  <div className="mobile-menu mean-container">
                    <div className="mean-bar">
                      <Link
                        to="#nav"
                        className="meanmenu-reveal"
                        style={{
                          right: "0px",
                          left: "auto",
                          display: "inline",
                        }}
                      >
                        <span>
                          <span>
                            <span></span>
                          </span>
                        </span>
                      </Link>
                      <nav className="mean-nav">
                        <ul
                          className="multipage-menu"
                          style={{ display: "none" }}
                        >
                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Home
                            </NavLink>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/about"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              About
                            </NavLink>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/business-portfolio"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Business Portfolio
                            </NavLink>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/csr"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              CSR
                            </NavLink>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/gallery"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Gallery
                            </NavLink>
                          </li>

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/news-media"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              News Media
                            </NavLink>
                          </li>

                          {/* <li className="menu-item-has-children">
                            <Link to="#">Pages</Link>
                            <ul
                              className="submenu last-children"
                              style={{ display: "none" }}
                            >
                              <li className="has-arrow">
                                <Link to="#">Services</Link>
                                <ul
                                  className="submenu"
                                  style={{ display: "none" }}
                                >
                                  <li>
                                    <Link to="services">Services</Link>
                                  </li>
                                  <li>
                                    <Link to="services-details">
                                      Services Details
                                    </Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                              <li className="has-arrow">
                                <Link to="#">Team</Link>
                                <ul
                                  className="submenu"
                                  style={{ display: "none" }}
                                >
                                  <li>
                                    <Link to="team">Team</Link>
                                  </li>
                                  <li>
                                    <Link to="team-details">Team Details</Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                              <li className="has-arrow">
                                <Link to="#">Project</Link>
                                <ul
                                  className="submenu"
                                  style={{ display: "none" }}
                                >
                                  <li>
                                    <Link to="portfolio">Project</Link>
                                  </li>
                                  <li>
                                    <Link to="portfolio-details">
                                      Project Details
                                    </Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                              <li>
                                <Link to="pricing">Pricing Plan</Link>
                              </li>
                              <li className="has-arrow">
                                <Link to="shop">Shop</Link>
                                <ul
                                  className="submenu"
                                  style={{ display: "none" }}
                                >
                                  <li>
                                    <Link to="shop">Product</Link>
                                  </li>
                                  <li>
                                    <Link to="shop-details">
                                      Product Details
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="checkout">Checkout</Link>
                                  </li>
                                  <li>
                                    <Link to="cart">Cart</Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                              <li>
                                <Link to="faq">Faq</Link>
                              </li>
                              <li>
                                <Link to="appointment">Appointment</Link>
                              </li>
                            </ul>
                            <Link
                              className="mean-expand"
                              to="#"
                              style={{ fontSize: "18px" }}
                            >
                              <i className="fa-regular fa-plus"></i>
                            </Link>
                          </li> */}

                          {/* <li className="has-mega-menu">
                            <Link to="#">Elements</Link>
                            <ul
                              className="mega-menu mega-grid"
                              style={{ display: "none" }}
                            >
                              <li>
                                <Link to="#" className="title">
                                  Elements Layout
                                </Link>
                                <ul style={{ display: "none" }}>
                                  <li>
                                    <Link to="elements-features">Features</Link>
                                  </li>
                                  <li>
                                    <Link to="elements-advance-tab">
                                      Advance Tab
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="elements-work-process">
                                      Work Process
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="elements-counter">Counter</Link>
                                  </li>
                                  <li>
                                    <Link to="elements-gsap">GSAP</Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="title">
                                  Elements Layout
                                </Link>
                                <ul style={{ display: "none" }}>
                                  <li>
                                    <Link to="elements-services">
                                      Services Box
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="elements-team">Team</Link>
                                  </li>
                                  <li>
                                    <Link to="elements-pricing">Pricing</Link>
                                  </li>
                                  <li>
                                    <Link to="elements-portfolio">Project</Link>
                                  </li>
                                  <li>
                                    <Link to="#">Coming Soon</Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="title">
                                  Elements Layout
                                </Link>
                                <ul style={{ display: "none" }}>
                                  <li>
                                    <Link to="elements-services-tab">
                                      Services Tab
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="elements-testimonial">
                                      Testimonials
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="elements-brand">
                                      Partner Logo
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="elements-blog">Blog</Link>
                                  </li>
                                  <li>
                                    <Link to="#">Coming Soon</Link>
                                  </li>
                                </ul>
                                <Link
                                  className="mean-expand"
                                  to="#"
                                  style={{ fontSize: "18px" }}
                                >
                                  <i className="fa-regular fa-plus"></i>
                                </Link>
                              </li>
                            </ul>
                            <Link
                              className="mean-expand"
                              to="#"
                              style={{ fontSize: "18px" }}
                            >
                              <i className="fa-regular fa-plus"></i>
                            </Link>
                          </li> */}

                          <li className="has-mega-menu" onClick={closeMenu}>
                            <NavLink
                              to="/contact"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              Contact
                            </NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>
                    <div className="rs-offcanvas-menu mb-25">
                      <nav></nav>
                    </div>
                  </div>
                </div>
              </div>

              <div className="offcanvas-contact mb-30">
                <h4 className="offcanvas-title-meta">Contact Info</h4>
                <ul>
                  <li className="d-flex align-items-center gap-15">
                    <div className="offcanvas-contact-icon">
                      <IoLocation size={18} color="#FF5C00" />
                    </div>

                    <div className="offcanvas-contact-text">
                      <Link to="#">
                        Natun Babu Para, Aminul Haq Road, <br />
                        Saidpur, Saidpur-5310, Nilphamari
                      </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center gap-15">
                    <div className="offcanvas-contact-icon">
                      <FiPhoneCall size={16} color="#FF5C00" />
                    </div>
                    <div className="offcanvas-contact-text">
                      <Link to="tel:01833688844"> 01833688844 </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center gap-15">
                    <div className="offcanvas-contact-icon">
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M2 2C0.895431 2 0 2.89543 0 4V12L2.58386e-05 12.0103C0.00555998 13.1101 0.898859 14 2 14H7.5C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13H2C1.53715 13 1.14774 12.6855 1.03376 12.2586L6.67417 8.7876L8 9.5831L15 5.3831V8.5C15 8.77614 15.2239 9 15.5 9C15.7761 9 16 8.77614 16 8.5V4C16 2.89543 15.1046 2 14 2H2ZM5.70808 8.20794L1 11.1052V5.3831L5.70808 8.20794ZM1 4.2169V4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4V4.2169L8 8.4169L1 4.2169Z"
                          fill="#6D6D6D"
                        ></path>
                        <path
                          d="M14.2467 14.2686C15.2567 14.2686 15.8339 13.4116 15.8339 12.2442V12.0344C15.8339 10.4297 14.6402 9 12.5197 9H12.4847C10.421 9 9 10.3598 9 12.4322V12.6465C9 14.8195 10.4385 16 12.3579 16H12.4016C12.9963 16 13.4204 15.9257 13.639 15.8251V15.0949C13.3941 15.2042 12.9656 15.2742 12.4585 15.2742H12.4147C11.0812 15.2742 9.84385 14.4872 9.84385 12.6202V12.4628C9.84385 10.8057 10.9019 9.73891 12.4847 9.73891H12.524C14.0587 9.73891 15.0075 10.7883 15.0075 12.065V12.183C15.0075 13.158 14.6839 13.5734 14.3691 13.5734C14.1374 13.5734 13.9582 13.4247 13.9582 13.1537V10.9631H13.0531V11.5315H13.0225C12.9394 11.2342 12.6552 10.9019 12.0693 10.9019C11.2911 10.9019 10.8101 11.4572 10.8101 12.3011V12.8301C10.8101 13.722 11.2998 14.2642 12.0693 14.2642C12.5415 14.2642 12.9656 14.0369 13.0837 13.6215H13.1274C13.2455 14.0412 13.7439 14.2686 14.2467 14.2686ZM11.7939 12.6814V12.4541C11.7939 11.9076 12.0212 11.6627 12.3666 11.6627C12.664 11.6627 12.9394 11.8551 12.9394 12.371V12.7383C12.9394 13.3111 12.6858 13.4816 12.3754 13.4816C12.0212 13.4816 11.7939 13.2673 11.7939 12.6814Z"
                          fill="#6D6D6D"
                        ></path>
                      </svg> */}
                      <MdOutlineEmail size={16} color="#6D6D6D" />
                    </div>
                    <div className="offcanvas-contact-text">
                      <Link to="mailto:info@gmail.com">
                        infoequegroup@gmail.com
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="offcanvas-social">
                <h4 className="offcanvas-title-meta">Subscribe & Follow</h4>
                <ul>
                  <li>
                    <Link to="#">
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-x-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-youtube"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fab fa-linkedin"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`offcanvas-overlay ${menuOpen ? "overlay-open" : ""}`}
      ></div>
      <div className="offcanvas-overlay-white"></div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  /* 🔥 Active menu color */
  .main-menu a.active {
    color: #ff5c00 !important;
  }

  /* Optional hover effect */
  .main-menu a:hover {
    color: #ff5c00;
  }
`;

export default Offcanvas;
